/*
Copyright (c) 2026 Jim Thatcher

This software is the property of Jim Thatcher, and may not be used without permission.
*/
window.ROSTER = (function(my) {
  my.cid = 0;
  my.tid = 0;
  my.query = {};
  my.getRoster = my.getRoster || function() {};
  my.yrToGrade = my.yrToGrade || function(n) {};
  return my;
} (window.ROSTER || {}));

var tableHeader = '<tr><th style="width:12%">#</th><th>Player</th><th>Grade</th><th>Position</th><th>Height</th><th>Weight</th></tr>';

function getCookie(name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
};

function yrToGrade(n) {
    var s = ["FR", "SO", "JR", "SR"];
    return s[n-9];
}

async function parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    // If the query string does not contain cid and tid, check the org and team cookies
    if (!query['cid'] && !query['tid']) {
        var org = getCookie("org");
        var team = getCookie("team");
        if (org && team) {
            query['cid'] = org;
            query['tid'] = team;
          } else {
            // parse the org and team slugs from the path (after the /public/pagename/ part) and look up the ids from /rest/lookupteam
            var path = window.location.pathname;
            var pathParts = path.split('/');
            var orgSlug = pathParts[pathParts.length - 2];
            var teamSlug = pathParts[pathParts.length - 1];
            console.debug("Looking up team: " + orgSlug + '/' + teamSlug);
            await fetch('/rest/lookupteam/' + orgSlug + '/' + teamSlug)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                query['cid'] = data['cid'];
                query['tid'] = data['tid'];
                console.debug("Found team: " + query['cid'] + '/' + query['tid']);
            })
            .catch(function(err) {
                console.error("Error looking up team: " + err);
            });
        }
    }
    console.debug("Query: " + JSON.stringify(query));
    return query;
};

ROSTER.getRoster = async function () {
    // Read the roster from database
    console.debug("Getting roster for " + ROSTER.cid + '/' + ROSTER.tid);
    fetch('/rest/db/players?cid=' + ROSTER.cid + '&tid=' + ROSTER.tid)
    .then(function (response) {
        if (response.status === 401) {
            // Unauthorized: delete the token and reload the page
            console.log("Unauthorized");
        } else {
            return response.json();
        }
    })
    .then(function (data) {
        var element = document.getElementById("roster-list");
        var header = document.createElement("tr");
        header.innerHTML = tableHeader;
        element.appendChild(header);
        for (var i = 0; i < data.length; i++) {
            var row = document.createElement("tr");
            var jerseyElement = document.createElement("td");
            jerseyElement.innerHTML = data[i].jersey;
            row.appendChild(jerseyElement);
            var nameElement = document.createElement("td");
            nameElement.innerHTML = data[i].name;
            row.appendChild(nameElement);
            var yearElement = document.createElement("td");
            yearElement.innerHTML = data[i].year > 0 ? yrToGrade(data[i].year) : '';
            row.appendChild(yearElement);
            var positionElement = document.createElement("td");
            positionElement.innerHTML = data[i].position;
            row.appendChild(positionElement);
            var heightElement = document.createElement("td");
            heightElement.innerHTML = data[i].height[0] != '0' ? data[i].height : '';
            row.appendChild(heightElement);
            var weightElement = document.createElement("td");
            weightElement.innerHTML = data[i].weight > 0 ? data[i].weight + 'lbs' : '';
            row.appendChild(weightElement);
            element.appendChild(row);
        }
    })
    .catch(function (err) {
        console.log('error: ' + err);
    })
};

async function initializeRoster() {
  ROSTER.query = await parseQuery(window.location.search);
  ROSTER.cid = (ROSTER.query['cid']) ? ROSTER.query.cid : 0;
  ROSTER.tid = (ROSTER.query['tid']) ? ROSTER.query.tid : 0;
  console.debug("Roster: " + ROSTER.cid + '/' + ROSTER.tid);

  if (!!ROSTER.cid && !!ROSTER.tid) {
    ROSTER.getRoster();
  }
}
initializeRoster();
